/**
 * Indian invoicing utilities shared across InvoicesPage, InvoiceFormPage, InvoiceViewPage.
 */

/** Format an ISO date "YYYY-MM-DD" as DD/MM/YYYY for display. */
export const fmtDateIN = (iso) => {
  if (!iso) return '—';
  // Accept both date-only (YYYY-MM-DD) and full ISO timestamps
  const datePart = String(iso).slice(0, 10);
  const m = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
};

/** Format an INR amount with Indian numbering and ₹ prefix. */
export const fmtINR = (n) =>
  `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
